import axios from "axios";
import {
  Button,
  MenuItem,
  Tooltip,
} from "@mui/material";
import styles from "./style.module.css";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Box from "@mui/material/Box";
import {
  GridColDef,
  GridPrintExportMenuItem,
  GridToolbarContainer,
  GridToolbarExportContainer,
  useGridApiContext,
} from "@mui/x-data-grid";
import CircularModal from '../../custom/circularModalLoader/circularModalLoader';
import ReportsTable from '../../custom/reportsTable';
import { inventoryOnHandData } from "../../../utils/constant";
import Title from "../../custom/Title";
import { AuthContext } from "../../../contexts/AuthContext";
import useService from "../../../hooks/useService";
import { getInventoryOnHandReport } from "../../../services/Reports";
import moment from "moment";

const DataGridContainer = styled.div`
  height: calc(100%);
  overflow-x: auto;
`
const InventoryType: any = {
  1: 'Normal SKU',
  2: 'Cut Bar/Loose Items',
  3: 'Buffing dust',
  4: 'Scrap from barter/buy sell',
  5: 'Jobwork Metal',
  6: 'GMS Metal',
  7: 'Non-Serialized SKU'
}

export const InventoryOnHand = () => {
  let sessionId: any = localStorage.getItem("sessionId")
  const [loading, setLoading] = useState(false)
  const [inventoryOnHand, setInventoryOnHand] = useState<any>([])
  const [destinationOptions, setDestinationOptions] = useState<any>([])
  const [pvcCenters, setPvcCenters] = useState([])
  const { user: { centerId }, pvcAddresses } = useContext(AuthContext)
  const { execute } = useService()
  const [CenterName, setCenterName] = useState<any>([])


  const getDestination = async () => {
    console.log(centerId,'centeID')
    try {
      setLoading(true)
      const params = { sessionid: sessionId }
      const response = await axios.post(
        "/api/commerce/inventoryManagement/fetchBusinessUnits",
        params
      )
      setLoading(false)
      setDestinationOptions(response?.data)
    } catch (error) {
      setLoading(false)
      console.error(error)
    //   errorToast("Unable to get destinations!")
    }
  }

  useEffect(() => {
    setCenterName(pvcAddresses[0]?.displayName)
  }, [pvcAddresses])

  const getInventoryOnHand = async () => {
    try {
      if(pvcCenters.length === 0) {
        // return errorToast('Please select pvcCenters!')
      }

      let destinations: any = []

      pvcCenters.forEach((center: any) => {
        destinations.push(center?.value)
      })

      setLoading(true)
      const params = {
        // sessionId: sessionId,
        channelId: centerId
      }

    //   const response = await axios.post(
    //     "/api/pvcReports/getInventoryOnHand",
    //     params
    //   )
      const { data } = await execute(() => getInventoryOnHandReport({params}))

      setLoading(false)
      setInventoryOnHand(data?.data || [])
    } catch (error) {
      setLoading(false)
      console.error(error)
    //   errorToast('Unable to get Inventory On hand details!')
    }
  }

  const getInventoryOnHandColumns = () => {
    let minWidth = 100

    return inventoryOnHandData.map((inboundField: any) => {

      const row: GridColDef = {
        field: inboundField.id,
        headerName: inboundField.label,
        minWidth,
        align: 'left'
      }

      switch (inboundField.id) {
        case "itemNo":
          row.minWidth = 200;
          row.renderCell = params => {
            return params.row.itemNo ? params.row.itemNo : "N/A"
          }
          break;
        case "itemDescription":
          row.minWidth = 250;
          row.renderCell = params => {
            return <Tooltip title={params.row.itemDescription}>
              {params.row.itemDescription ? params.row.itemDescription : "N/A"}
            </Tooltip> 
          }
          break;
        case "metal":
          row.minWidth = 120;
          row.renderCell = params => {
            return params.row.metal ? params.row.metal : "N/A"
          }
          break;
        case "inventoryType":
            row.minWidth = 200;
            row.valueGetter = (params) => {
              return params.row.inventoryType ? InventoryType[params.row.inventoryType] : "N/A" };
            row.renderCell = (params) => { return params.value };
          break;   
        case "fineWeight":
            row.minWidth = 120;
            row.valueGetter = params => {
              return params.row.fineWeight ? ( params.row.itemNo ==="Buffing Dust Loss"? '-' + params.row.fineWeight : params.row.fineWeight) : 0
            }
            row.renderCell = (params) => { return params.value };
          break;
        case "inventoryLocation":
          row.minWidth = 400;
          row.renderCell = params => {
            return <Tooltip title={params.row.inventoryLocation}>
              {params.row.inventoryLocation ? params.row.inventoryLocation : "N/A"}
            </Tooltip> 
          }
          break;
        case "qtyOnHand":
          row.minWidth = 120;
          row.renderCell = params => {
            return params.row.qtyOnHand ? params.row.qtyOnHand : 0
          }
          break;
        case "qtyAvailableForSale":
          row.minWidth = 180;
          row.renderCell = params => {
            return params.row.qtyAvailableForSale ? params.row.qtyAvailableForSale : 0
          }
          break;
        case "qtyAvailableForTransfer":
          row.minWidth = 180;
          row.renderCell = params => {
            return params.row.qtyAvailableForTransfer ? params.row.qtyAvailableForTransfer : 0
          }
          break;
        case "qtyInTransitInbound":
          row.minWidth = 180;
          row.renderCell = params => {
            return params.row.qtyInTransitInbound ? params.row.qtyInTransitInbound : 0
          }
          break;
        case "qtyInTransitOutbound":
          row.minWidth = 180;
          row.renderCell = params => {
            return params.row.qtyInTransitOutbound ? params.row.qtyInTransitOutbound : 0
          }
          break;
        case "fineMetalBaseUnit":
          row.minWidth = 180;
          row.renderCell = params => {
            return params.row.fineMetalBaseUnit ? params.row.fineMetalBaseUnit : 0
          }
          break;
        case "netMetalBaseUnit":
          row.minWidth = 180;
          row.renderCell = params => {
            return params.row.netMetalBaseUnit ? params.row.netMetalBaseUnit : 0
          }
          break;
        default:
          row.minWidth = 100
          break;
      }
      return row;
    })
  }

  const filterModal = () => {
    return (
      <Box className={styles.filterModal}>
        <Box className={styles.InventoryFilterModalRow}>
          <Box className={styles.boxModal}>
            <Title>{CenterName}</Title>
          </Box>
          <Box>
            <Button
              variant="contained"
              onClick={getInventoryOnHand}
              endIcon={<SearchIcon />}
            >
              Search
            </Button>
          </Box>
        </Box>
      </Box>
    )
  }

  useEffect(() => {
    getDestination();
  }, [])

  const CustomToolbar = () => {
    const apiRef = useGridApiContext();

    const handleExport = () => {
      const csvData = apiRef.current.getDataAsCsv();
      const modifiedCsv = `Exported on:,"${moment().format('DD/MM/YYYY hh:mm a')}"\n\n${csvData}`;

      const blob = new Blob([modifiedCsv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `inventoryOnHand.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    return (
      <GridToolbarContainer>
        <GridToolbarExportContainer>
          <MenuItem onClick={handleExport}>
            Download as CSV
          </MenuItem>
          <GridPrintExportMenuItem />
        </GridToolbarExportContainer>
      </GridToolbarContainer>
    )
  }

  const renderTable = () => {
    return (
      <>
        <div>
          {loading && <CircularModal thickness={4} />}
          <Box sx={{ width: "100%", height: '500px', overflow: 'auto' }}>
            <DataGridContainer>
              <ReportsTable
                className="payrollGrid"
                rows={inventoryOnHand || []}
                columns={getInventoryOnHandColumns()}
                getRowId={(row) => row.id}
                disableRowSelectionOnClick={true}
                rowHeight={50}
                slots={{ toolbar: CustomToolbar }}
                hideFooter={true}
                fixedHeight={true}
              />
            </DataGridContainer>
          </Box>
        </div>
      </>
    );
  }

  return (
    <Box className={styles.container}>
    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Inventory On Hand Report</Title>
      {filterModal()}
      {renderTable()}
    </Box>
  )
}

export default InventoryOnHand